type KbdKeyProps = { children: React.ReactNode };

export default function KbdKey({ children }: KbdKeyProps) {
  return <span className="kbd-key">{children}</span>;
}
